class Storage
{
    constructor() {
            this.key = '_cache';
    }

    get(index, defaultValue) {

            let data = window.sessionStorage.getItem(this.key + "_" + index);
            if (!data) {

                    if (typeof(defaultValue) != 'undefined') {
                            return defaultValue;
                    }
                    return null;
            }

            return JSON.parse(data);
    }

    set(index, data) {
            window.sessionStorage.setItem(this.key + "_" + index, JSON.stringify(data));
    }

    remove(index) {
            window.sessionStorage.removeItem(this.key + "_" + index);
    }

}

export default Storage;